<template>
  <div>
    <commBanner :obj="obj"></commBanner>
    <titleHead :headTitle="headTitle"></titleHead>
    <div class="w80 mb-60">
      <el-container>
        <el-aside width="330px">
          <sidebar></sidebar>
        </el-aside>
        <el-main>
          <div>
            <companySide v-if="type" :isButton="isButton" @release ="gorelease()"></companySide>
            <headSide v-else @release ="gorelease()"></headSide>
            <contTitle
              class="mt-40"
              :obj="obj"
              :contTitle="contTitle"
            ></contTitle>
            <div class="change_conent mt-20">
              <div class="change_bater">
                <el-form
                  class="mt-40"
                  :model="resetForm"
                  :rules="resetFormRules"
                  :label-position="labelPosition"
                  ref="resetForm"
                  label-width="130px"
                >
                  <el-form-item
                    label="新密码："
                    prop="newpwd"
                    style="width: 80%"
                  >
                    <el-input
                      type="password"
                      v-model="resetForm.newpwd"
                      auto-complete="off"
                      show-password
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="确认新密码："
                    prop="newpassword"
                    style="width: 80%"
                  >
                    <el-input
                      type="password"
                      v-model="resetForm.newpassword"
                      auto-complete="off"
                      show-password
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    class="code"
                    label="验证码："
                    prop="verificationCode"
                    style="width: 80%"
                  >
                    <el-input
                      type="text"
                      v-model="resetForm.verificationCode"
                      auto-complete="off"
                    ></el-input>
                    <img
                      class="graphic_code"
                      :src="imgUrl"
                      alt=""
                      @click.prevent="getCaptcha()"
                      />
                  </el-form-item>
                  <el-form-item
                    label="发送手机号码："
                    style="width: 80%"
                  >
                    <p class="phone_tel">{{telPhone}}</p>
                    <!-- <el-input type="password" v-model="resetForm.phoneNumber" auto-complete="off"></el-input> -->
                  </el-form-item>
                  <el-form-item
                    class="phone"
                    label="手机验证码："
                    prop="phoneCode"
                    style="width: 80%"
                  >
                    <el-input
                      type="text"
                      v-model="resetForm.phoneCode"
                    ></el-input>
                    <button class="shortBtn" @click.prevent="onCode()">
                      {{getCodeText}}
                    </button>
                  </el-form-item>
                  <el-form-item class="box_reset">
                    <button class="reset" @click.prevent="toAmend('resetForm')">
                      确认修改
                    </button>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
    </div>
  </div>
</template>
<script>
import {userphone,sendSmsCaptcha,changePassword} from "@/api/my";
import { getUUID } from "@/utils/index";
import {getToken} from '@/utils/auth'
import commBanner from "../../common/commBanner";
import sidebar from "../../common/sidebar";
import companySide from "../../common/companySide";
import headSide from "../../common/headSide";
import titleHead from "../../common/titleHead";
import contTitle from "../../common/contTitle";
export default {
  components: { commBanner, sidebar, titleHead, contTitle, headSide ,companySide},
  data() {
    var validatePass = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入新密码"));
      } else if (value.toString().length < 6 || value.toString().length > 18) {
        callback(new Error("密码长度为6-18位"));
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.resetForm.newpwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      headTitle: "修改密码",
      contTitle: "修改密码",
      obj: {
        title: "修改密码",
        contCount: "",
        isShow: false,
        roleType:'',
        personalType:9
        // content:
        //   "公司主营产品及服务包括:金属氧化物避雷器带电检测仪、数字式钳形伏安相位表、大型地网接地电阻测量仪、多通道波形记录仪、PT感应耐压试验电源、高压高稳定电源...",
        // bannerUrl: require("@/assets/images/banner.jpg"),
      },
      labelPosition: "left",
      resetForm: {
        newpwd: "", //新密码
        newpassword: "", //确认新密码
        verificationCode: "", //验证码
        phoneNumber: "",
        phoneCode: "",
      },

      resetFormRules: {
        newpwd: [{ required: true, validator: validatePass, trigger: "blur" }],
        newpassword: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
        verificationCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
        phoneCode: [
          { required: true, message: "请输入手机验证码", trigger: "blur" },
        ],
      },
      imgUrl:'',
      getCodeText:'获取验证码',
      telPhone:'',
      uid:'',
      type:false,
      isButton:false
    };
  },
  created(){
    this.getCaptcha();
    this.getPhone();
    let type = this.$store.state.user.userInfo.type;
    this.obj.roleType = type;
    if(type == 3){
      this.type = true;
    }
  },
  methods: {
    //修改密码
    toAmend(formName) {
      this.$refs.resetForm.validate((valid) => {
        if (valid) {
          let params ={
            mobile:this.telPhone,
            smsCode:this.resetForm.phoneCode,
            password:this.resetForm.newpwd
          };
          changePassword(params).then(res=>{
            if(res.code ==0){
                this.$message({
                  message: "修改成功",
                  type: "success",
                  duration: 1000,
                  onClose:()=>{
                   this.$store.dispatch("user/logout");
                   this.$router.push({
                      path: "/login",
                    });
                  }
                });
            }
          }).catch(err=>{})
        }
      });
    },
    //获取图形验证码
    getCaptcha() {
        this.uid = getUUID();
        this.imgUrl = `/api/zwb/app/captcha.jpg?uuid=${this.uid}`;
    },
    //发送验证码
     onCode(){
       if(!this.resetForm.verificationCode){
         this.$message({
           message: "请输入图形验证码",
           type: "warning",
           duration: 1000,
         })
         return;
       }
        let params = {
          uuid:this.uid,
          imgCode: this.resetForm.verificationCode,
       };
       this.setTimer();
       sendSmsCaptcha(params).then(res =>{
         if (res.code == 0) {
            this.$message({
              message: "验证码发送成功",
              type: "success",
              duration: 1000,
            });
          }
       }).catch(err=>{})
     },
     //倒计时
     setTimer() {
        let holdTime = 60;
        this.getCodeText = "重新获取(60)";
        this.Timer = setInterval(() => {
          if (holdTime <= 0) {
            this.getCodeisWaiting = false;
            this.getCodeText = "获取验证码";
            holdTime = 60;
            clearInterval(this.Timer);
            return;
          }
          this.getCodeText = "重新获取(" + holdTime + ")";
          holdTime--;
        }, 1000);
     },
     //获取手机号
     getPhone(){
       let parmas={};
       userphone(parmas).then(res=>{
         if(res.code ==0){
            this.telPhone = res.data;
         }
       }).catch(err=>{})
     },
     //发布需求
     gorelease(){
       this.$router.push('/demand')
     }
  },

};
</script>
<style scoped>
.fcl {
  display: flex;
  justify-content: left;
}
.mt-10 {
  margin-top: 10px;
}
.mt-20 {
  margin-top: 20px;
}
.mt-40 {
  margin-top: 40px;
}
.mb-60 {
  margin-bottom: 60px;
}
.change_conent {
  width: 100%;
  background: #FFFFFF;
  opacity: 0.9;
}
.change_bater {
  margin: 20px 0px;
}
.change_bater >>> .el-input__inner {
  height: 50px;
}
.box_reset >>> .el-form-item__content {
  margin-left: 0px !important;
}
.reset {
  margin-top: 20px;
  width: 129px;
  height: 35px;
  line-height: 11px;
  background: #3CBB36;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
}
.el-form-item {
  text-align: left;
}
.code {
  position: relative;
}
.graphic_code {
  position: absolute;
  right: 0;
  top: 0;
  width: 125px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 21px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  background: #cdcdcd;
  color: #323232;
}
.phone {
  position: relative;
}
.shortBtn {
  position: absolute;
  top: 0;
  right: 0;
  width: 125px;
  height: 50px;
  background: #e5e5e5;
  /* border: 1px solid #999999;
  opacity: 0.2; */
}
.phone_tel {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
</style>


// WEBPACK FOOTER //
// src/view/coment/password_change.vue